import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { AppState } from '../../app-wide/app/app.state';
import { loadDepotsFailure, loadDepotsSuccess, loadExternalCredentialsFailure, loadExternalCredentialsSuccess, OrganizationActionTypes } from './organization.actions';
import { Depot } from '../../../shared/models/depot.interface';
import { OrganizationService } from '../../../services/organization.service';
import { ExternalCredentials } from '@por/shared/core';

@Injectable()
export class OrganizationEffects {
    private readonly actions$ = inject(Actions);
    private readonly organizationService = inject(OrganizationService);
    private readonly store = inject<Store<AppState>>(Store);

    loadDepots$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OrganizationActionTypes.LoadDepots),
            switchMap((action: { organizationId: string }) => {
                return this.organizationService.getDepots(action.organizationId).pipe(
                    map((depots: Depot[]) => {
                        return loadDepotsSuccess({ depots });
                    }),
                    catchError(error => {
                        return of(loadDepotsFailure({ error: error.message }));
                    })
                );
            })
        )
    );

    loadExternalCredentials$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OrganizationActionTypes.LoadExternalCredentials),
            switchMap((action: { organizationId: string }) => {
                return this.organizationService.getExternalCredentials(action.organizationId).pipe(
                    map((externalCredentials: ExternalCredentials[]) => {
                        return loadExternalCredentialsSuccess({ externalCredentials });
                    }),
                    catchError(error => {
                        return of(loadExternalCredentialsFailure({ error: error.message }));
                    })
                );
            })
        )
    );
}
